<template>
  <div id="RenewPopup">
    <div class="top">
      <div class="print" @click="printComponent()">Print</div>
    </div>
    <div id="invoice">
      <div class="header">
        <img src="@/assets/logo_primary.svg" />
        <h1>Club Seat License Agreement</h1>
        <p class="subtitle">Stadium Management Company, LLC ("Licensor")</p>
      </div>
      <div class="account-info">
        <div class="account-title">Account Information</div>
        <p>
          <span>Account #:</span> {{ global.userInfo.Account }} <br />
          <span>Name:</span> {{ global.userInfo.ownerName }} <br />
          <span>Phone:</span> {{ global.userInfo.phone }} <br />
          <span>Email:</span> {{ global.userInfo.email }} <br />
          <span>Address:</span> {{ global.userInfo.address }}, {{ global.userInfo.city }}, {{ global.userInfo.state }} {{ global.userInfo.zip }}
        </p>
      </div>
      <div class="grey-bar"></div>
      <div class="preference">
        <div class="numOfSeats">Number of Club Seats Requested: <span>{{ getTotalSeats }}</span></div>
        <div class="performance-deposit">
          <div class="pd-title">Performance Deposit</div>
          <p>Number of Club Seats: <span>{{ getTotalSeats }}</span> x $250 = <span>{{ getTotalSeats*250 | toCurrency }}</span></p>
          <div class="pd-note">* The performance deposit is a one-time security deposit due with a multi-year agreement (separate from the cost of the tickets) and is fully refundable down the road when the seats are given back to us upon a non-renewal at the end of your term</div>
        </div>
        <div class="price-and-terms">
          <div class="pNt-title">2024 Prices/Term Preference:</div>
          <div class="pNt-info" v-if="global.userInfo.zoneType == 'PURPLE'">
            <p><span>&check;</span> PURPLE ZONE</p>
            <p>$3,100</p>
            <p>(South corner and zone)</p>
          </div>
          <div class="pNt-info" v-if="global.userInfo.zoneType == 'ORANGE'">
            <p><span>&check;</span> ORANGE ZONE</p>
            <p>$3,450</p>
            <p>(corner and zone to end line)</p>
          </div>
          <div class="pNt-info" v-if="global.userInfo.zoneType == 'GRAY'">
            <p><span>&check;</span> GRAY ZONE</p>
            <p>$4,200</p>
            <p>(end zone to 20-yard line)</p>
          </div>
          <div class="pNt-info" v-if="global.userInfo.zoneType == 'RED'">
            <p><span>&check;</span> RED ZONE</p>
            <p>$4,800</p>
            <p>(between the 20-yard line)</p>
          </div>
        </div>
      </div>
      <div class="term-agreement">
        <div class="ta-title">Select Agreement Term</div>
        <div class="ta-button-cnt">
          <div class="ta-button">
            <label for="two-year-term">2-Year License Term</label>
            <input type="radio" v-model="agreementTerm" name="agreementTerm" value="two-year-term" :checked="agreementTermChecked == 'two-year-term'"/>
          </div>
          <div class="ta-button">
            <label for="four-year-term">4-Year License Term</label>
            <input type="radio" v-model="agreementTerm" name="agreementTerm" value="four-year-term" :checked="agreementTermChecked == 'four-year-term'"/>
          </div>
          <div class="ta-button">
            <label for="four-year-term">6-Year License Term</label>
            <input type="radio" v-model="agreementTerm" name="agreementTerm" value="six-year-term" :checked="agreementTermChecked == 'six-year-term'"/>
          </div>
        </div>
        <div class="ta-note">*5% escalator is scheduled for each subsequent year of the agreement term.</div>
      </div>
      <div class="account-summary">
        <div class="chart">
          <div class="row item">
            <span class="c0">Description</span>
            <span class="c1"># Of Seats</span>
            <span class="c2">Price</span>
            <span class="c3">Total</span>
          </div>
          <div 
            class="row"
            v-for="(info, index) in global.allUserAccs"
            :key="'seating' + index"
            :class="'row' + index"
          >
            <span class="c0">{{ info.zoneType }} ZONE</span>
            <span class="c1">{{ info.numOfSeats }}</span>
            <span class="c2">{{ Number(info.amountPerSeat) | toCurrency }}</span>
            <span class="c3">{{ Number(info.amountTotal) | toCurrency }}</span>
          </div>
          <div 
            class="row"
            v-for="(info, index) in global.allParkingAccs"
            :key="'seating' + index"
            :class="'row' + index"
          >
            <span class="c0">Parking Lot</span>
            <span class="c1">{{ info.numOfSeats }}</span>
            <span class="c2">{{ Number(info.amountPerSeat) | toCurrency }}</span>
            <span class="c3">{{ Number(info.amountTotal) | toCurrency }}</span>
          </div>
          <div class="summary">
            <div class="total">
              <div class="row">
                <span>Credit:</span>
                <span v-if="global.parkingInfo.Account == global.userInfo.Account" class="number">{{ getCredit + getParkingCredit | toCurrency }}</span>
                <span v-else>{{ getCredit | toCurrency }}</span>
              </div>
              <div class="row">
                <span>Performance Deposit:</span>
                <span class="number">{{ getTotalSeats*250 | toCurrency }}</span>
              </div>
              <div class="row due">
                <span>Total Due:</span>
                <span v-if="global.parkingInfo.Account == global.userInfo.Account">{{ (getTotalDue + getParkingTotalDue) + (getTotalSeats*250) - (getCredit + getParkingCredit)  | toCurrency }}</span>
                <span v-else>{{ getTotalDue + (getTotalSeats*250) - getCredit  | toCurrency }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="account-summary-shaded">
        <div class="account-sum-title">Shaded Portion To Be Completed By SMC</div>
        <div 
          class="account-sum-info"
          v-for="(info, index) in global.allUserAccs"
            :key="'seating' + index"
            :class="'row' + index"
        >
          <p>
            Section: {{ info.section }}
            <span>|</span>
            Row: {{ info.row }}
            <span>|</span>
            Seat(s): {{ info.firstSeat }}-{{ info.lastSeat }}
          </p>
        </div>
      </div>
      <div class="cheque-note">
        <p>
          Please sign this Agreement where provided on the following page and attach your check in payment of the performance deposit ($250 per Club Seat) and License Fee for First License Year.  If you wish to pay by credit card, please utilize the payment portal in the Account Manager.
          <br /><br />
          Make check payable to: STADIUM MANAGEMENT COMPANY, LLC
          <br /><br />
          <span>Send signed Agreement (with check, if applicable) to: </span><br />
          Stadium Management Company, LLC<br />
          Denver Broncos Ticket Office<br />
          Empower Field at Mile High<br />
          1701 Bryant Street, Suite 100
        </p>
      </div>
      <div class="terms-and-conditions">
        <div class="TnC-title"><p>Terms And Conditions</p></div>
        <p>
          Licensee acknowledges and agrees to be bound by this Club Seat License Agreement (including the terms set forth in the pamphlet entitled "Stadium Management Company Club Seat License Agreement, Terms and Conditions and Club Seat Pricing Schedule) (the "Pamphlet"), of which the Licensee acknowledges receipt and which is incorporated herein by this reference.  In addition, Licensee agrees to observe all Stadium Rules (as defined in the Pamphlet).  The defined terms used in this Cover Page shall have the same meaning as set forth in the Pamphlet.
          <br /><br />
          The license (the "License") provided under this Agreement to use the Club Seat(s) shall commence on the last date written below.
          <br /><br />
          <a href="https://broncos.vipfanportal.com/2023/pdf/2023-Club-Seat-License-Agreement.pdf" target="_blank">Click here</a>
          to download the Agreement.
        </p>
      </div>
      <div class="licensor-and-licensee">
        <div class="licensor-cnt">
          <div class="licensor-title">Licensor</div>
          <p>
            STADIUM MANAGEMENT COMPANY, LLC<br />
            a Colorado limited liability company
            <br /><br />
            Marc Jackson<br />
            Vice President, Ticketing Sales and Service
          </p>
          <div class="inputBox">
            <input type="text" v-model="licensorBy"/>
            <div class="input-title">By</div>
          </div>
          <div class="inputBox">
            <input type="text" v-model="licensorDate"/>
            <div class="input-title">Date</div>
          </div>
        </div>
        <div class="licensee-cnt">
          <div class="licensee-title">Licensee</div>
          <div class="inputBox">
            <input type="text" v-model="licenseeName" />
            <div class="input-title">Licensee Name</div>
          </div>
          <div class="inputBox">
            <input type="text" v-model="licenseePrintName"/>
            <div class="input-title">Print Name</div>
          </div>
          <div class="inputBox">
            <input type="text" v-model="licenseeTitle"/>
            <div class="input-title">Title (if corporation, partnership, or LLC)</div>
          </div>
          <div class="inputBox">
            <input type="text" v-model="licenseeDate"/>
            <div class="input-title">Date</div>
          </div>
          <div class="inputBox">
            <input type="text" v-model="licenseeEmail"/>
            <div class="input-title">Email Address</div>
          </div>
          <div class="inputBox">
            <input type="text" v-model="licenseePhone"/>
            <div class="input-title">Day Telephone</div>
          </div>
          <div class="licenseeDescription-cnt">
            <p>Description of Licensee (Check One):</p>
            <div class="descBox-cnt">
              <div class="descBox">
                <label for="licenseeDescIndividual"><input type="radio" v-model="licenseeDescription" name="licenseeDescription" value="licenseeDescIndividual">Individual</label>
              </div>
              <div class="descBox">
                <label for="licenseeDescPartnership"><input type="radio" v-model="licenseeDescription" name="licenseeDescription" value="licenseeDescPartnership">Partnership*</label>
              </div>
              <div class="descBox">
                <label for="licenseeDescCorporation"><input type="radio" v-model="licenseeDescription" name="licenseeDescription" value="licenseeDescCorporation">Corporation*</label>
              </div>
              <div class="descBox">
                <label for="licenseeDescLLC"><input type="radio" v-model="licenseeDescription" name="licenseeDescription" value="licenseeDescLLC">Limited Liability Company*</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="agreement">
        <input
          type="text"
          size="50"
          v-model="signature"
          required
          title="Broncos Fan"
        />
        <p>Online Signature - Please type your first and last name</p>
        <div class="renewBtn" v-if="blank" @click="submitForm()">
          Renew Now
        </div>
        <div class="renewBtn grey" v-else>Renew Now</div>
        <div class="accepted" v-if="!blank">
          <p>Thank you for renewing your United Club Level season tickets. As a reminder, the first payment for the 2024 season is due by March 21, 2024. Click <a href="https://am.ticketmaster.com/broncos/" target="_blank">here</a> to login to Account Manager to arrange payment.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";

export default {
  name: "RenewPopup",
  computed: {
    ...mapState(["global"]),
    getTotalDue() {
      return this.global.allUserAccs
        .map((item) => Number(item.amountTotal))
        .reduce((prev, next) => prev + next);
    },
    getParkingTotalDue() {
      return this.global.allParkingAccs
        .map((item) => Number(item.amountTotal))
        .reduce((prev, next) => prev + next);
    },
    getCredit() {
      return this.global.allUserAccs
        .map((item) => Number(item.paidAmount))
        .reduce((prev, next) => prev + next);
    },
    getParkingCredit() {
      return this.global.allParkingAccs
        .map((item) => Number(item.paidAmount))
        .reduce((prev, next) => prev + next);
    },
    getTotalSeats() {
      return this.global.allUserAccs
        .map((item) => Number(item.numOfSeats))
        .reduce((prev, next) => prev + next);
    },
    licenseeName() {
      return this.global.userInfo.ownerName;
    },
  },
  data() {
    return {
      signature: "",
      agreementTerm: "",
      agreementTermChecked: "",
      licensorBy: "",
      licensorDate: "",
      licenseePrintName: "",
      licenseeTitle: "",
      licenseeDate: "",
      licenseeEmail: "",
      licenseePhone: "",
      licenseeDescription: "",
      blank: false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.signature = this.global.userInfo.signature;
      if (this.global.userInfo.signature === "") {
        this.blank = true;
      } else {
        this.blank = false;
      }
    }, 1000);
  },
  methods: {
    printComponent() {
      var printContent = document.getElementById("invoice").innerHTML;
      let stylesHtml = "./RenewPopup.scss";
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style'),
      ]) {
        stylesHtml += node.outerHtml;
      }

      const WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=900,toolbar=0,scrollbars=0,status=0"
      );

      WinPrint.document.write(`<!DOCTYPE html>
      <html>
        <head>
          ${stylesHtml}
        </head>
        <body>
          ${printContent}
        </body>
      </html>`);

      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    },
    async submitForm() {
      const purl = this.global.userInfo.purl;
      const formData = {
        signature: this.signature,
        timeOfSignature: new Date(),
        agreementTerm: this.agreementTerm,
        licensorBy: this.licensorBy,
        licensorDate: this.licensorDate,
        licenseeName: this.licenseeName,
        licenseePrintName: this.licenseePrintName,
        licenseeTitle: this.licenseeTitle,
        licenseeDate: this.licenseeDate,
        licenseeEmail: this.licenseeEmail,
        licenseePhone: this.licenseePhone,
        licenseeDescription: this.licenseeDescription,
      };
      console.table(formData);
      if (!purl) return;
      // Agreement Term
      if (this.agreementTerm.length < 2) { alert("Please select an agreement term"); return; }
      // Licensee
      if (this.licenseePrintName.length < 2) { alert("Please enter Licensee Print Name"); return; }
      if (this.licenseeDate.length < 2) { alert("Please enter Licensee Date"); return; }
      if (this.licenseeEmail.length < 2) { alert("Please enter Licensee Email"); return; }
      if (this.licenseePhone.length < 2) { alert("Please enter Licensee Phone Number"); return; }
      // Signature
      if (this.signature.length < 5) { alert("Please enter signature"); return; }

      const response = await axios.post(
        process.env.VUE_APP_BASE_URL + "/api/router/Forms.php",
        {
          action: "submitSurvey",
          prefix: "broncos2023",
          formValues: formData,
          accountId: this.global.userInfo.Account,
          ownerName: this.global.userInfo.ownerName,
          repName: this.global.userInfo.repName,
          repEmail: this.global.userInfo.repEmail,
          numOfSeats: this.global.userInfo.numOfSeats,
          timestamp: new Date(),
        }
      );
      alert("Thank you for renewing your United Club Level season tickets. As a reminder, the first payment for the 2023 season is due by March 24, 2023. https://am.ticketmaster.com/broncos/ to login to Account Manager to arrange payment.");
    },
  },
};
</script>

<style lang="scss" scoped>
#RenewPopup {
  width: 100%;
  max-width: 940px;
  background-color: #fff;
  margin: 0;
  h1 {
    font-family: AvenirNextCondensed-Bold;
    font-size: 24px;
    line-height: 30px;
    color: #f26522;
    padding: 0 50px;
    margin-top: 15px;
  }
  h2 {
    font-family: AvenirNextCondensed-Bold;
    font-size: 20px;
    line-height: 30px;
    color: #666;
    text-align: center;
    padding: 0 50px;
    span {
      font-family: AvenirNextCondensed-Medium;
    }
  }
  h3 {
    font-family: AvenirNextCondensed-Bold;
    font-size: 20px;
    line-height: 50px;
    text-align: center;
    color: #061632;
    border-top: 1px solid #061632;
    border-bottom: 1px solid #061632;
    margin-bottom: 25px;
    background: #ccc;
    padding: 0 50px;
    width: 100%;
  }
  h4 {
    font-family: AvenirNextCondensed-Bold;
    font-size: 20px;
    line-height: 28px;
    color: #000;
    text-align: center;
    padding: 0 50px;
  }
  p {
    font-family: AvenirNextCondensed-Medium;
    font-size: 14px;
    line-height: 18px;
    color: #000;
    padding: 0 50px;
    &.subtitle {
      color: #FFF;
      margin-top: 10px;
    }
  }

  .top {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
    width: 100%;
    background: #f26522;
    .print {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 130px;
      padding: 5px;
      font-family: AvenirNextCondensed-Bold;
      font-family: 20px;
      line-height: 20px;
      text-transform: uppercase;
      color: #061632;
      border: 2px solid #061632;
      background: #fff;
      cursor: pointer;
    }
  }
  #invoice {
    display: flex;
    flex-direction: column;
    .header {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 25px 0;
      width: 100%;
      background-color: #111B2E;
      @media (max-width: $md) {
        text-align: center;
        h1, h2, h3, h4, p {
          padding: 0 20px;
        }
      }
      img {
        height: 53px;
        object-fit: contain;
      }
      h1 {
        color: #FFF;
        text-transform: uppercase;
      }
      h2 {
        text-transform: uppercase;
      }
    }
    .account-info {
      position: relative;
      display: flex;
      flex-direction: column;
      padding: 40px 50px 20px;
      @media (max-width: $md) {
        padding: 20px;
      }
      .account-title {
        font-family: AvenirNextCondensed-Bold;
        font-size: 19px;
        line-height: 24px;
        font-weight: 700;
        color: #F26522;
      }
      p {
        padding: 0;
        span {
          font-family: AvenirNextCondensed-Bold;
        }
      }
    }
    .grey-bar {
      position: relative;
      display: flex;
      width: 100%;
      height: 10px;
      background-color: #EEE;
    }
    .preference {
      padding: 35px 50px 40px;
      @media (max-width: $md) {
        padding: 20px;
      }
      .numOfSeats {
        margin-bottom: 40px;
        font-size: 14px;
        font-family: AvenirNextCondensed-Medium;
        line-height: 21px;
        color: #000;
        @media (max-width: $md) {
          margin-bottom: 20px;
        }
        span {
          font-family: AvenirNextCondensed-Bold;
          color: #F26522;
        }
      }
      .performance-deposit {
        margin-bottom: 20px;
        .pd-title {
          margin-bottom: 10px;
          font-size: 17px;
          font-family: AvenirNextCondensed-BoldItalic;
          line-height: 21px;
          color: #000;
        }
        p {
          padding: 0;
          font-size: 14px;
          font-family: AvenirNextCondensed-Medium;
          line-height: 19px;
          color: #000;
          span {
            color: #F26522;
          }
        }
        .pd-note {
          margin-top: 10px;
          font-size: 12px;
          font-family: AvenirNextCondensed-Medium;
          line-height: 17px;
          color: #000;
        }
      }
      .price-and-terms {
        .pNt-title {
          margin-bottom: 10px;
          font-size: 17px;
          font-family: AvenirNextCondensed-BoldItalic;
          line-height: 21px;
          color: #000;
        }
        .pNt-info {
          position: relative;
          display: flex;
          justify-content: flex-start;
          width: 100%;
          p {
            margin-right: 25px;
            padding: 0;
            font-size: 14px;
            font-family: AvenirNextCondensed-Medium;
            line-height: 19px;
            color: #000;
            span {
              margin-right: 5px;
              color: #F26522;
            }
          }
          @media (max-width: $sm) {
            flex-direction: column;
            p {
              margin-right: 0;
              margin: 5px 0;
            }
          }
        }
      }
    }
    .term-agreement {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 25px 50px;
      background-color: #EEE;
      .ta-title {
        margin-bottom: 10px;
        font-size: 17px;
        font-family: AvenirNextCondensed-BoldItalic;
        line-height: 21px;
        text-transform: uppercase;
        color: #000;
      }
      .ta-button-cnt {
        position: relative;
        display: flex;
        justify-content: center;
        .ta-button {
          position: relative;
          display: inline-flex;
          margin: 5px;
          input[type=radio] {
            cursor: pointer;
            position: relative;
            padding: 10px;
            width: 218px;
            height: 37px;
            background: #D1D1D1;
            -webkit-appearance: none;
            outline: none;
          }
          input[type=radio]:checked {
            background: #F26522;
          }
          label {
            z-index: 1;
            pointer-events: none;
            position: absolute;
            display: block;
            left: 50%;
            top: 50%;
            width: 100%;
            margin: 0;
            text-align: center;
            font-size: 16px;
            font-family: AvenirNextCondensed-BoldItalic;
            line-height: 15px;
            text-transform: uppercase;
            color: #000;
            transform: translate(-50%, -50%);
            -ms-transform: translate(-50%, -50%);
          }
        }
      }
      .ta-note {
        margin-top: 20px;
        font-size: 12px;
        font-family: AvenirNextCondensed-Medium;
        line-height: 17px;
        color: #000;
      }
      @media (max-width: $sm) {
        padding: 25px 20px;
        .ta-button-cnt {
          flex-direction: column;
        }
        .ta-note {
          text-align: center;
        }
      }
    }
    .account-summary {
      padding: 40px 50px;
      .chart {
        position: relative;
        display: block;
        width: 100%;
        height: auto;
        .row {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          height: auto;
          &.item {
            padding: 10px 0;
            span {
              font-family: AvenirNextCondensed-Bold;
              font-size: 17px;
              line-height: 19px;
              text-transform: uppercase;
              color: #000;
              @media (max-width: $md) {
                font-size: 15px;
                line-height: 17px;
              }
              @media (max-width: $sm) {
                font-size: 13px;
                line-height: 15px;
              }
            }
          }
          span {
            font-family: AvenirNextCondensed-Medium;
            font-size: 14px;
            line-height: 19px;
            padding: 0 5px;
            text-align: left;
            color: #000;
            &.c0 { width: 275px; }
            &.c1 { width: 225px; }
            &.c2 { width: 200px; }
            &.c3 { width: 100px; text-align: right; }
            &.number { font-family: AvenirNextCondensed-Bold; }
            @media (max-width: $md) {
              font-size: 12px;
              line-height: 17px;
              &.c0 { width: 26%; }
              &.c1 { width: 26%; }
              &.c2 { width: 28%; }
              &.c3 { width: 20%; }
            }
            @media (max-width: $sm) {
              &.c0 { width: 30%; }
              &.c1 { width: 22%; }
              &.c2 { width: 28%; }
              &.c3 { width: 20%; }
            }
          }
        }
        .summary {
          position: relative;
          display: flex;
          justify-content: flex-end;
          width: 100%;
          margin-top: 20px;
          .total {
            position: relative;
            display: block;
            width: 48%;
            .row {
              border-bottom: 0;
              span {
                color: #F26522;
                @media (max-width: $sm) {
                  font-size: 10px;
                  line-height: 15px;
                }
              }
              &.due {
                margin-top: 5px;
                padding-top: 5px;
                span {
                  font-family: AvenirNextCondensed-Bold;
                  font-size: 20px;
                  line-height: 1;
                  color: #F26522;
                  @media (max-width: $sm) {
                    font-size: 14px;
                  }
                }
              }
            }
          }
        }
      }
      @media (max-width: $sm) {
        padding: 20px;
      }
    }
    .account-summary-shaded {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 25px 50px;
      background-color: #EEE;
      .account-sum-title {
        margin: 15px;
        font-size: 14px;
        font-family: AvenirNextCondensed-Bold;
        line-height: 19px;
        text-transform: uppercase;
        color: #000;
      }
      .account-sum-info {
        position: relative;
        display: inline-flex;
        justify-content: center;
        p {
          font-size: 14px;
          font-family: AvenirNextCondensed-Medium;
          line-height: 19px;
          color: #000;
          span {
            position: relative;
            display: inline;
            margin: 0 10px;
          }
        }
      }
      @media (max-width: $sm) {
        padding: 25px 20px;
        .account-sum-info {
          p {
            padding: 0;
            span {
              margin: 0 5px;
            }
          }
        }
      }
    }
    .cheque-note {
      position: relative;
      display: flex;
      justify-content: center;
      padding: 50px 50px 30px;
      p {
        font-size: 14px;
        font-family: AvenirNextCondensed-Medium;
        line-height: 19px;
        text-align: center;
        color: #000;
        span {
          font-family: AvenirNextCondensed-Bold;
          color: #F26522;
        }
      }
      @media (max-width: $sm) {
        padding: 25px 20px;
        p {
          padding: 0;
        }
      }
    }
    .terms-and-conditions {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-bottom: 50px;
      .TnC-title {
        position: relative;
        display: flex;
        justify-content: center;
        width: 100%;
        margin-bottom: 40px;
        background-color: #EEE;
        p {
          padding: 22px 0;
          font-size: 17px;
          font-family: AvenirNextCondensed-BoldItalic;
          line-height: 21px;
          text-transform: uppercase;
          color: #000;
        }
      }
      p {
        a {
          text-decoration: none;
          color: #f26522;
        }
      }
      .second {
        margin-top: 15px;
      }
      .pricing {
        display: flex;
        flex-direction: column;
        width: 100%;
        max-width: 400px;
        padding: 0 50px;
        margin-top: 20px;
        &__row {
          display: flex;
          flex-direction: row;
          width: 100%;
          padding-left: 10px;
          &.titleRow {
            border-bottom: 1px solid #061632;
            background: #ccc;
            font-family: AvenirNextCondensed-Bold;
            font-size: 16px;
            line-height: 20px;
            white-space: nowrap;
            color: #061632;
            text-transform: uppercase;
          }
          &.contentRow {
            .year {
              font-family: AvenirNextCondensed-Bold;
              font-size: 16px;
              color: #061632;
              font-size: 16px;
              line-height: 20px;
              white-space: nowrap;
            }
            .content {
              font-family: AvenirNextCondensed-Medium;
              font-size: 16px;
              line-height: 20px;
              color: #f26522;
              white-space: nowrap;
              text-align: center;
            }
          }
          .cell {
            padding: 10px 0;
            text-align: center;
            &.year {
              flex: 1;
            }
            &.content {
              flex: 2;
            }
          }
        }
      }
      @media (max-width: $sm) {
        padding-bottom: 25px;
        .TnC-title {
          margin-bottom: 20px;
        }
        p {
          padding: 0 20px;
        }
      }
    }
    .licensor-and-licensee {
      position: relative;
      display: flex;
      width: 100%;
      padding: 0 0 50px;
      .licensor-cnt {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        max-width: 450px;
        padding: 20px 30px;
        background: #EEE;
        .licensor-title {
          margin-bottom: 20px;
          font-size: 17px;
          font-family: AvenirNextCondensed-BoldItalic;
          line-height: 21px;
          text-transform: uppercase;
          color: #000;
        }
        p {
          padding: 0;
          font-family: AvenirNextCondensed-Medium;
          font-size: 14px;
          line-height: 19px;
          text-align: center;
          color: #000;
        }
        .inputBox {
          position: relative;
          display: flex;
          flex-direction: column;
          width: 100%;
          margin-top: 20px;
          &:last-child {
            margin-top: 10px;
          }
          input[type="text"] {
            font-family: AvenirNextCondensed-Medium;
            width: 100%;
            height: 25px;
            font-size: 14px;
            line-height: 19px;
            color: #061632;
            border: 0;
            border-bottom: 1px solid #000;
            background-color: #FFF;
            margin: 0;
            padding: 6px 5px;
            outline: none;
          }
          .input-title {
            position: relative;
            display: flex;
            justify-self: start;
            padding-left: 5px;
            font-family: AvenirNextCondensed-Medium;
            font-size: 14px;
            line-height: 19px;
            text-align: left;
            color: #000;
          }
        }
      }
      .licensee-cnt {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        max-width: 450px;
        padding: 20px 30px;
        .licensee-title {
          margin-bottom: 5px;
          font-size: 17px;
          font-family: AvenirNextCondensed-BoldItalic;
          line-height: 21px;
          text-transform: uppercase;
          color: #000;
        }
        .inputBox {
          position: relative;
          display: flex;
          flex-direction: column;
          width: 100%;
          margin-top: 10px;
          &:first-child {
            margin-top: 0;
          }
          input[type="text"] {
            font-family: AvenirNextCondensed-Medium;
            width: 100%;
            height: 25px;
            font-size: 14px;
            line-height: 19px;
            color: #061632;
            border: 0;
            border-bottom: 1px solid #000;
            background-color: #F6F6F6;
            margin: 0;
            padding: 6px 5px;
            outline: none;
          }
          .input-title {
            position: relative;
            display: flex;
            justify-self: start;
            padding-left: 5px;
            font-family: AvenirNextCondensed-Medium;
            font-size: 14px;
            line-height: 19px;
            text-align: left;
            color: #000;
          }
        }
        .licenseeDescription-cnt {
          position: relative;
          display: flex;
          flex-direction: column;
          width: 100%;
          margin-top: 15px;
          p {
            padding: 0 5px;
            font-size: 14px;
            font-family: AvenirNextCondensed-BoldItalic;
            line-height: 19px;
            text-transform: uppercase;
            color: #000;
          }
          .descBox-cnt {
            position: relative;
            display: flex;
            flex-wrap: wrap;
            width: 100%;
            .descBox {
              position: relative;
              display: inline-flex;
              margin-right: 25px;
              margin-top: 12px;
              input[type=radio] {
                width: 17px;
                height: 17px;
                margin-right: 10px;
                -webkit-appearance: none;
                border: 1px solid black;
                &:checked {
                  display: inline-block;
                  background: #000;
                }
              }
              label {
                position: relative;
                display: inline-flex;
                margin-bottom: 0;
                font-size: 14px;
                font-family: AvenirNextCondensed-Medium;
                line-height: 19px;
                color: #000;
              }
            }
          }
        }
      }
      @media (max-width: $sm) {
        flex-direction: column;
        padding: 0 0 25px;
      }
    }
    .agreement {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      padding: 0 20px 25px;
      h2 {
        span {
          color: #f26522;
        }
      }
      input {
        font-family: "MarketWeb";
        font-weight: 700;
        font-style: normal;
        width: 100%;
        max-width: 350px;
        height: 50px;
        font-size: 24px;
        line-height: 50px;
        text-align: center;
        color: #061632;
        border: 0;
        border-bottom: 1px solid #000;
        background-color: rgba(239, 239, 239, 0.5);
        margin: 0 0 10px 0;
        outline: none;
      }
      p {
        margin-bottom: 15px;
      }
      .renewBtn {
        font-family: AvenirNextCondensed-Bold;
        font-size: 20px;
        line-height: 20px;
        text-align: center;
        text-transform: uppercase;
        color: #061632;
        background: #f26522;
        border: 2px solid #061632;
        margin: 10px auto;
        padding: 10px;
        width: 150px;
        cursor: pointer;
        &.grey {
          background: #ccc;
          cursor: default;
        }
      }
      .accepted {
        max-width: 610px;
        font-family: AvenirNextCondensed-Medium;
        font-size: 16px;
        line-height: 30px;
        text-align: center;
        color: #061632;
        a {
          text-decoration: none;
          color: #f26522;
        }
      }
    }
  }
}
</style>